

<nz-form-item>
  @if (!opts.hideLabel) {
    <nz-form-label class="" nzFor="">{{ product?.gcsSize &&  product?.gcsSize > 1 ? ('bus.booking.guests' | actrans) : product?.mkGcs[0] ||  label || ('bus.booking.guests' | actrans) }}</nz-form-label>
  }
  <nz-form-control>

    <button
      nz-button
      nzBlock
      [nzSize]="view.size"
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="guestsPopup"
      [(nzVisible)]="guestsPopupVisible"
      (nzVisibleChange)="guestsPopupVisibleChange($event)"
      class="text-left"
      >
      <span nz-icon nzType="user"></span>
      <span class="text-lg-off"> {{ getGcs() }}</span>

    </button>
    <nz-dropdown-menu #guestsPopup="nzDropdownMenu">

      <div nz-menu>
        <i nz-icon nzType="close" class="pull-right p-3" (click)="guestsPopupClose()" ></i>

        <div class="p-3">

          @for (cat of categories; track cat) {
            <div>
              @if (cat.max !== 0) {
                <div class="grid grid-cols-2 gap-4">
                  <div> <nz-form-label  [nzFor]="'gc' + cat.idx">{{ cat.mk | actrans }}</nz-form-label></div>
                  <div>
                    <nz-space [nzSize]="'small'">
                      <button
                        *nzSpaceItem
                        nz-button
                        nzType="primary"
                        nzShape="circle"
                        (click)="decrementGcValue(cat.idx)" >
                        <i nz-icon nzType="minus-circle"></i>
                      </button>
                      <input
                        *nzSpaceItem
                        nz-input
                        [(ngModel)]="gcs.map[cat.idx]"
                        (ngModelChange)="onGcChange(cat.idx)"
                        [name]="'gc' + cat.idx"
                        class="text-center"
                        style="width: 50px;" />
                      <button
                        *nzSpaceItem
                        nz-button
                        nzType="primary"
                        nzShape="circle"
                        (click)="incrementGcValue(cat.idx)" ><i nz-icon nzType="plus-circle"></i></button>
                      </nz-space>
                    </div>
                  </div>
                }
              </div>
            }

            <div class="text-right mt-8">
              <button
                nz-button
                nzBlock
                nzType="primary"
                (click)="guestsPopupClose()"
                >
                {{ 'common.select' | actrans }}
              </button>
            </div>

          </div>
        </div>

      </nz-dropdown-menu>
    </nz-form-control>
  </nz-form-item>
